export default "__VITE_ASSET__DZHtF9z3__"